<template>
  <span
    class="bg-blue-grey inline-flex items-center text-xs ltr:pl-3 rtl:pr-3 text-black whitespace-no-wrap"
  >
    {{ model }}
    <button
      role="button"
      class="inline-flex items-center justify-center h-8 w-8"
      @click="removeTerm()"
    >
      <span class="sr-only">Remove Term</span>
      <IconCross
        height="10px"
        width="10px"
        stroke="#16213e"
      />
    </button>
  </span>
</template>

<script>
import IconCross from '@/assets/icons/icon-cross.svg'

export default {
  components: {
    IconCross
  },
  props: {
    model: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // iconClose
    }
  },
  methods: {
    removeTerm() {
      this.$emit('removeTerm', this.model)
    }
  }
}
</script>
